module.exports = __webpack_public_path__ + "img/Party.47308153.svg";